module.exports = "<span class=\"status-label label\" [ngClass]=\"{'active': active}\">\r\n  {{ active ? getActiveText() : getInactiveText() }}\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/components/common/statusLabel/statusLabel.component.html
// module id = ../../../../../src/app/components/common/statusLabel/statusLabel.component.html
// module chunks = main